import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import mocRatings from "../../../../src/data/articles/cube-prospective-march-of-the-machine-commander/moc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  mocRatings,
  ProspectiveIntro,
  React
};